module.exports = __webpack_public_path__ + "img/icon_j7.7d37603.png";